import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { SupportWidgetProvider } from './contexts/SupportWidgetContext'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SupportWidgetProvider>
          <App />
        </SupportWidgetProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)